import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const ShieldSecuredOutline = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M12 6.5H20C22.2091 6.5 24 8.29086 24 10.5V15.8208C24 19.4151 21.5239 22.4479 18.2062 24.4055C16.85 25.208 15.15 25.208 13.7938 24.4055C10.4761 22.4479 8 19.4151 8 15.8208V10.5C8 8.29086 9.79086 6.5 12 6.5ZM13.091 15.4025L15.2728 17.2548L18.9091 12.9529" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper strokeWidth={1} {...props} variant="outline" viewBox="0 0 32 32">{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { ShieldSecuredOutline };